import React, { createContext, useContext } from 'react';

export type CustomSelectContextProps = {
    id: string;
    onValueChange: (value: string) => void;
    value: string | undefined;
    open: boolean;
    toggleOpen: () => void;
    onClose: () => void;
    onKeyDownSelect: (event: React.KeyboardEvent<HTMLButtonElement>) => void;
    onKeyDownItem: (event: React.KeyboardEvent<HTMLButtonElement>, item: string) => void;
    setButtonRef: (button: HTMLButtonElement) => void;
    setListRef: (list: HTMLUListElement) => void;
};

const CustomSelectContext = createContext({
    id: '',
    open: false,
    onClose: () => null,
    toggleOpen: () => null,
    value: undefined,
    onValueChange: () => null,
    onKeyDownSelect: () => null,
    onKeyDownItem: () => null,
    setButtonRef: () => null,
    setListRef: () => null,
} as CustomSelectContextProps);

export const useCustomSelectContext = () => useContext(CustomSelectContext);

export default CustomSelectContext;
